import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {MenuFormType} from "../../../store/menu/forms";
import {localize} from "../../../../../common/libs";
import {SnackbarType} from "../../../../../stores/common";
import style from "./../style.module.css";
import {useHistory} from "react-router-dom";
import {Space} from "../../../../../common/components/libs";

const DeleteMenuItemForm = () => {
    const {t} = useTranslation(["general", "menu"]);
    const {menuStore, generalStore} = useStores();
    const history = useHistory();
    const forms = menuStore.forms;
    const {open, current} = forms.forms[MenuFormType.deleteMenuItem];
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    if (!current) return null;

    const submitDelete = async (e: React.MouseEvent) => {

        e.preventDefault();
        e.stopPropagation();

        if (!current) return;
        const res = await menuStore.removeMenuItem(current.menuId, current.id);
        const menuId = current.menuId;
        if (res.err) {
            generalStore.showSnackbar({
                type: SnackbarType.error,
                title: t("menu:menuEditor.errorWhileDeletingPosition")
            })
        } else {
            generalStore.showSnackbar({
                type: SnackbarType.success,
                title: t("menu:menuEditor.positionSuccessfullyDeleted")
            });
            menuStore.forms.closeForm(MenuFormType.deleteMenuItem);
            history.push(`/menus/regular/${menuId}/view`);
        }
    }


    return (
        <Dialog
            open={open}
            onClose={() => {
                menuStore.forms.closeForm(MenuFormType.deleteMenuItem)
            }
            }
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title" className={style.deleteContent}>
                {t("menu:deleteMenuItem")}
            </DialogTitle>
            <DialogContent className={style.deleteContent}>
                {t("menu:youGoingRemoveMenuItem")} '{localize(current.data.name)}'.
                <br/>
                {t("menu:itIsUndone")}

            </DialogContent>

            <DialogActions>
                <div style={{marginBottom: "30px"}}>
                    <Button
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            e.stopPropagation();
                            menuStore.forms.closeForm(MenuFormType.deleteMenuItem)
                        }}
                        color="primary">
                        {t("general:cancel")}
                    </Button>
                    <Button
                        color="default"
                        onClick={submitDelete}
                    >
                        {t("menu:modifiersSet.wantDelete")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default observer(DeleteMenuItemForm);


